import { sendExportOrder } from "../../../../../api/server/order";
import type { OrderExportForm } from "../types/orderExportTypes";

export const exportOrders = (form: OrderExportForm) => sendExportOrder({
  account: form.account,
  warehouse: form.warehouse.flatMap((item) => item.originalValues ?? [item.value]),
  status: form.status.map((item) => item.value),
  fileType: form.fileType,
  from_time: `${form.fromDate} ${form.fromTime} GMT+0700`,
  to_time: `${form.toDate} ${form.toTime} GMT+0700`,
  urlFile: form.templateUrl,
});
